import React,{useContext, useMemo} from "react";
import QRGenerator from "./qr-generator";
import { profileURL } from "utils/utils";
import { SubscriptionContext } from "context/subscription";

const useProfileURLs = () =>
  useMemo(() => {
    const base = profileURL();
    return { milestone: base, reels: `${base}?showreel=true` };
  }, []);

const QRMilestone = ({value="milestone", className="", preview = false})=>{
    return (
      <>
      {
        preview ? 
        <div className={`flex ${className}`}>
            <div className="h-14 w-14 relative">
                <QRGenerator value={value}></QRGenerator>

                
            </div>
        </div> :

        <div className={`flex ${className}`}>
            <div className="h-18 w-18 relative">
                <QRGenerator value={value}></QRGenerator>

            </div>
        </div> 
      }
      </>
    );
}

const TitleMileston = ({className})=>{
    return(
        <div className={`${className}`}>
            <h2 className=" font-semibold">Scan here to view my Milestones Page Profile</h2> 
        </div>
    );
}

const TitleReels = ({className})=>{
    return(
        <div className={` ${className}`}>
            <h2 className="font-semibold">Scan here to view my Showreels Videos</h2>
        </div>
    );
}

const SubTitleMilestone = ({className})=>{
    const { milestone } = useProfileURLs();
    return(
        <p className={`${className}`}>or go direct to the url below:<br/>
                            {milestone}
        </p>
    );
}

const SubTitleReels = ({className})=>{
    const { reels } = useProfileURLs();
    return(
            <p className={`${className}`}>or go direct to the url below:<br/>
                    {reels}
            </p> 
    );
}

const QRResume = ({show_qr_milestone,show_qr_reels})=>{
    const { isSubscribed } = useContext(SubscriptionContext);
    const { milestone, reels } = useProfileURLs();

    return(
        <div className="flex w-full gap-4 items-center justify-center">
            {
                show_qr_milestone &&
                <div className="flex rounded-md p-2 items-center gap-2 flex-wrap bg-[#E5EFFA] "> 
                    <div className="px-2 mt-1 w-32">
                        <QRMilestone value={milestone} className="justify-center items-center"/>
                        <TitleMileston className="text-[.50rem] mt-1 text-center break-all"/>
                    </div>
                </div>
            }

            {
                show_qr_reels && isSubscribed &&
                <div className="flex rounded-md p-2 items-center gap-2 flex-wrap bg-[#E5EFFA]">
                    <div className="px-2 mt-1 w-32">
                        <QRMilestone value={reels} className="justify-center items-center"/>
                        <TitleReels className="text-[.50rem] mt-1 text-center break-all"/>
                    </div>
                </div>
            }

        </div>
    )
}
export default QRResume;

export const QRResume_TEMP_2 = ({show_qr_milestone,show_qr_reels})=>{
    const { isSubscribed } = useContext(SubscriptionContext);
    const { milestone, reels } = useProfileURLs();

    return(
        <div className="flex w-full gap-4">
            {
                show_qr_milestone &&
                <div className="flex border border-gray rounded-md p-2 items-center gap-2"> 
                    <QRMilestone value={milestone}/>
                    <div> 
                        <TitleMileston className="text-[.60rem] mt-1"/>
                        <SubTitleMilestone className="text-[.50rem] mt-1 break-all" /> 
                    </div>
                </div>
            } 
            {
                show_qr_reels && isSubscribed &&
                <div className="flex border border-gray rounded-md p-2 items-center gap-2">
                    <QRMilestone value={reels}/>
                    <div>
                        <TitleReels className="text-[.60rem] mt-1"/>
                        <SubTitleReels className="text-[.50rem] mt-1 break-all"/>
                    </div>
                </div>
            }

        </div>
    )
}

export const QRResume_TEMP_3 = ({show_qr_milestone,show_qr_reels})=>{
    const { milestone, reels } = useProfileURLs();
    return(
        <div className="flex w-full gap-4">
            {
                show_qr_milestone &&
                <div className="flex rounded-md p-2 items-center gap-2"> 
                    <QRMilestone value={milestone}/>
                    <div> 
                        <TitleMileston className="text-[.60rem] mt-1 text-white"/>
                        <SubTitleMilestone className="text-[.50rem] mt-1 text-white break-all" /> 
                    </div>
                </div>
            } 
            <div className="h-full w-px bg-gray-400"></div>
            {
                show_qr_reels &&
                <div className="flex rounded-md p-2 items-center gap-2">
                    <QRMilestone value={reels}/>
                    <div>
                        <TitleReels className="text-[.60rem] mt-1 text-white"/>
                        <SubTitleReels className="text-[.50rem] mt-1 text-white break-all"/>
                    </div>
                </div>
            }

        </div>
    )
}

export const QRResume_TEMP_4 = ({show_qr_milestone,show_qr_reels})=>{
    const { isSubscribed } = useContext(SubscriptionContext);
    const { milestone, reels } = useProfileURLs();

    return(
        <div className="flex w-full gap-4">
            {
                show_qr_milestone &&
                <div className="flex rounded-md p-2 items-center gap-2"> 
                    <QRMilestone value={milestone}/>
                    <div> 
                        <TitleMileston className="text-[.60rem] mt-1"/>
                        <SubTitleMilestone className="text-[.50rem] mt-1 break-all" /> 
                    </div>
                </div>
            } 
            <div className="h-full w-px bg-gray-400"></div>
            {
                show_qr_reels && isSubscribed &&
                <div className="flex rounded-md p-2 items-center gap-2">
                    <QRMilestone value={reels}/>
                    <div>
                        <TitleReels className="text-[.60rem] mt-1 "/>
                        <SubTitleReels className="text-[.50rem] mt-1 break-all"/>
                    </div>
                </div>
            }

        </div>
    )
}

export const QRResume_TEMP_5 = ({show_qr_milestone,show_qr_reels, preview=false})=>{
    const { isSubscribed } = useContext(SubscriptionContext);
    const { milestone, reels } = useProfileURLs();

    return(
        <div className="flex w-full gap-2">
            {
                show_qr_milestone &&
                <div className="flex flex-row-reverse border border-[#041E36] rounded-md p-2 items-center gap-6 w-1/2 box-border relative"> 
                    <QRMilestone value={milestone} preview={preview}/>
                    <div> 
                        <TitleMileston className={`${preview ? 'text-[.60rem]' : 'text-[.75rem]'} mt-1`}/>
                        <SubTitleMilestone className={`${preview ? 'text-[.50rem]' : 'text-[.55rem]'} mt-1 break-all`} /> 
                    </div>
                </div>
            } 
            <div className="h-full w-px bg-gray-400"></div>
            {
                show_qr_reels && isSubscribed &&
                <div className="flex flex-row-reverse border border-[#041E36] rounded-md p-2 items-center gap-2 w-1/2 box-border relative">
                    <QRMilestone value={reels} preview={preview}/>
                    <div>
                        <TitleReels className={`${preview ? 'text-[.60rem]' : 'text-[.75rem]'} mt-1`}/>
                        <SubTitleReels className={`${preview ? 'text-[.50rem]' : 'text-[.55rem]'} mt-1 break-all`} /> 
                    </div>
                </div>
            }

        </div>
    )
}


